import { useState } from "react";

function FuturesOptionsAlchemyModule() {
  const [activeModule, setActiveModule] = useState(null);

  const toggleModule = (index) => {
    setActiveModule(activeModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to the Alchemy of Trading",
      content: [
        "Understanding the concept of 'alchemy' in trading.",
        "The transformation of basic knowledge into successful trading strategies.",
      ],
    },
    {
      title: "Module 2: Foundations of Futures Contracts",
      content: [
        "The core mechanics of Futures contracts.",
        "The relationship between Futures, spot price, and market expectations.",
      ],
    },
    {
      title: "Module 3: The Magic of Leverage in Futures",
      content: [
        "Understanding leverage and its impact on returns and risk.",
        "How to use leverage wisely in Futures trading.",
      ],
    },
    {
      title: "Module 4: The Essence of Options Contracts",
      content: [
        "Decoding Calls and Puts: the building blocks of Options.",
        "The magical flexibility of Options contracts for hedging and speculation.",
      ],
    },
    {
      title: "Module 5: The Alchemy of Combining Futures & Options",
      content: [
        "Using Futures and Options together for more advanced strategies.",
        "How Futures can be used to hedge Options and vice versa.",
      ],
    },
    {
      title: "Module 6: The Power of Risk Management",
      content: [
        "Alchemizing risk into opportunity using stop-losses, position sizing, and risk-reward ratios.",
        "The role of margin in Futures and Options trading.",
      ],
    },
    {
      title: "Module 7: Transforming Market Sentiment into Strategy",
      content: [
        "Using sentiment analysis and market indicators to craft your trading strategy.",
        "How to identify bullish, bearish, and neutral market conditions.",
      ],
    },
    {
      title: "Module 8: The Goldmine: Trading Volatility",
      content: [
        "How to capitalize on volatility using Options.",
        "Using the VIX and implied volatility for better trading decisions.",
      ],
    },
    {
      title: "Module 9: The Secret of The Greeks",
      content: [
        "Mastering Delta, Gamma, Theta, Vega, and Rho: The secret ingredients for Options pricing.",
        "How the Greeks transform your understanding of Options pricing dynamics.",
      ],
    },
    {
      title: "Module 10: Pattern Recognition in Futures & Options",
      content: [
        "Using chart patterns (Head & Shoulders, Triangles, Flags, etc.) to predict market movement.",
        "Combining technical analysis with Futures & Options strategies.",
      ],
    },
    {
      title: "Module 11: Alchemy of Hedging with Futures & Options",
      content: [
        "Transforming risk into reward using Futures and Options to hedge portfolios.",
        "Using Options to protect against adverse price movements in Futures.",
      ],
    },
    {
      title: "Module 12: Advanced Strategies in Futures & Options",
      content: [
        "Complex strategies: Straddles, Strangles, Iron Condors, and Butterfly spreads.",
        "Mastering the art of risk-adjusted returns with advanced strategies.",
      ],
    },
    {
      title: "Module 13: Psychology of the Alchemist Trader",
      content: [
        "Transforming emotions like fear and greed into disciplined trading decisions.",
        "The importance of patience, self-control, and mindset in Futures and Options trading.",
      ],
    },
    {
      title: "Module 14: Backtesting and Strategy Refinement",
      content: [
        "Testing your Futures & Options strategies using historical data.",
        "The role of backtesting in perfecting trading alchemy.",
      ],
    },
    {
      title: "Module 15: Mastering the Alchemy of Futures & Options Trading",
      content: [
        "Bringing it all together: Developing your personal trading philosophy.",
        "Continuously adapting strategies based on market conditions and personal experiences.",
      ],
    },
  ];

  return (
    <div className="container py-5">
      <h1 className="text-center mb-4">Futures & Options Alchemy</h1>
      <p className="text-center text-muted mb-5">
        Discover the art and science of transforming knowledge into trading success.
      </p>
      <div className="accordion">
        {modules.map((module, index) => (
          <div key={index} className="mb-3">
            <div
              className="p-3 bg-dark text-white d-flex justify-content-between align-items-center"
              onClick={() => toggleModule(index)}
              style={{
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              <h5 className="m-0">{module.title}</h5>
              <span
                style={{
                  fontSize: "18px",
                  transform: activeModule === index ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              >
                ▼
              </span>
            </div>
            {activeModule === index && (
              <div
                className="p-3 bg-light border"
                style={{ borderRadius: "5px" }}
              >
                {module.content.map((item, i) => (
                  <p key={i} style={{ margin: "5px 0", fontSize: "14px" }}>
                    ➤ {item}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default FuturesOptionsAlchemyModule;
